export const COLOR_CSS_VAR_NAME_CONFIG = {
  own: '--sn-own-color-hsl',
  tenantRaw: '--sn-tenant-color-raw-hsl',
  tenant: '--sn-tenant-color-hsl',
  final: '--sn-color-hsl',
  finalComposed: '--sn-color',
} as const
